import React from "react";
import { useTranslation } from "react-i18next";
import checkmarkIcon from "../../assets/large_tick.svg";
import "../../styles/components/sidepanel/FeedbackSent.css";

const FeedbackSentView: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <div className="feedbacksent-success">
      <div className="feedbacksent-checkmark-wrapper">
        <img src={checkmarkIcon} alt={t("feedbackSent.successAlt")} className="feedbacksent-checkmark" />
      </div>
      <p className="feedbacksent-success-text">
        {t("feedbackSent.thankYou")}
        <br />
        {t("feedbackSent.meaningMessage")}
      </p>
    </div>
  );
};

export default FeedbackSentView;
